import React, { useState, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { Prompt } from "react-router-dom";

//MUI Components
import { makeStyles } from "@material-ui/core/styles";
import {
	Box,
	Button,
	TextField,
	Typography,
	Card,
	CardContent,
} from "@material-ui/core";
import { useSnackbar } from "notistack";

const useStyles = makeStyles((theme) => ({
	form: {
		width: "100%", // Fix IE 11 issue.
		marginTop: theme.spacing(1),
	},
	submit: {
		margin: theme.spacing(1, 0, 0),
	},
}));

function Profile(props) {
	const classes = useStyles();
	const { logout, user } = useAuth();
	const [newUserName, setNewUserName] = useState();
	const [newUserPassword, setNewUserPassword] = useState({});
	const [unsavedName, setUnsavedName] = useState(false);
	const [unsavedPassword, setUnsavedPassword] = useState(false);
	const { enqueueSnackbar } = useSnackbar();

	useEffect(() => {
		setNewUserName({ name: user.name });
	}, [user]);

	const onChangeName = (e) => {
		setNewUserName({ name: e.target.value });
		setUnsavedName(true);
	};

	const onChangePassword = (e) => {
		setNewUserPassword({ ...newUserPassword, [e.target.name]: e.target.value });
		setUnsavedPassword(true);
	};

	const submitChangeName = (e) => {
		e.preventDefault();

		fetch(`${process.env.REACT_APP_API_URL}/auth/updatedetails`, {
			method: "PUT",
			credentials: "include",
			body: JSON.stringify({
				name: newUserName.name,
				password: newUserPassword.password,
			}),
			headers: { "Content-Type": "application/json" },
		})
			.then((res) => res.json())
			.then((data) => {
				console.log(data);
				if (data.success) {
					setUnsavedName(false);
					enqueueSnackbar("Name updated successfully", {
						variant: "success",
					});
				} else {
					console.log(data);
					const nameErrorArray = data.error.split(",");
					nameErrorArray.forEach((error) => {
						enqueueSnackbar(`${error}`, { variant: "error" });
					});
				}
			});
	};

	const submitChangePassword = (e) => {
		e.preventDefault();

		//Remove any keys with an empty str as the value
		for (const key of Object.keys(newUserPassword)) {
			if (newUserPassword[key] === "") {
				delete newUserPassword[key];
			}
		}

		if (newUserPassword.password !== newUserPassword.confirmPassword) {
			return enqueueSnackbar(
				`Your new passwords do not match. Please try again.`,
				{
					variant: "error",
				}
			);
		} else {
			fetch(`${process.env.REACT_APP_API_URL}/auth/updatepassword`, {
				method: "PUT",
				credentials: "include",
				body: JSON.stringify({
					currentPassword: newUserPassword.currentPassword,
					newPassword: newUserPassword.password,
				}),
				headers: { "Content-Type": "application/json" },
			})
				.then((res) => res.json())
				.then((data) => {
					if (data.success) {
						setUnsavedPassword(false);
						enqueueSnackbar("Password updated successfully", {
							variant: "success",
						});
						setNewUserPassword();
					} else {
						const passwordErrorArray = data.error.split(",");
						passwordErrorArray.forEach((error) => {
							enqueueSnackbar(`${error}`, { variant: "error" });
						});
					}
				});
		}
	};

	return (
		<>
			<Prompt
				when={unsavedName}
				message="You have an unsaved name change. Would you still like to Leave?"
			/>
			<Prompt
				when={unsavedPassword}
				message="You have an unsaved password change. Would you still like to Leave?"
			/>
			<Box display="flex">
				<Typography variant="h4">Profile Settings</Typography>
				<Button
					style={{ marginLeft: "1rem" }}
					variant="contained"
					color="primary"
					onClick={logout}
				>
					Log Out
				</Button>
			</Box>
			<section className={classes.formSection}>
				<Card style={{ marginTop: "1rem" }}>
					<CardContent>
						<Typography variant="h5">Update Name</Typography>
						<form onSubmit={submitChangeName} className={classes.form}>
							<TextField
								variant="outlined"
								size="small"
								margin="normal"
								required
								fullWidth
								id="email"
								label="Email Address"
								autoComplete="email"
								value={user.email}
								disabled
							/>
							<TextField
								variant="outlined"
								size="small"
								margin="normal"
								required
								fullWidth
								id="name"
								label="Name"
								name="name"
								onChange={onChangeName}
								value={newUserName && newUserName.name}
							/>
							<Button
								type="submit"
								fullWidth
								variant="contained"
								color="primary"
								className={classes.submit}
							>
								Update Name
							</Button>
						</form>
					</CardContent>
				</Card>
				<Card style={{ marginTop: "1rem" }}>
					<CardContent>
						<Typography variant="h5">Update Password</Typography>
						<form onSubmit={submitChangePassword} className={classes.form}>
							<TextField
								variant="outlined"
								size="small"
								margin="normal"
								fullWidth
								name="currentPassword"
								label="Current Password"
								type="password"
								id="currentPassword"
								onChange={onChangePassword}
								required
								value={
									(newUserPassword && newUserPassword.currentPassword) ?? ""
								}
							/>
							<TextField
								variant="outlined"
								size="small"
								margin="normal"
								fullWidth
								name="password"
								label="New Password"
								type="password"
								id="password"
								onChange={onChangePassword}
								required
								value={(newUserPassword && newUserPassword.password) ?? ""}
							/>
							<TextField
								variant="outlined"
								size="small"
								margin="normal"
								fullWidth
								name="confirmPassword"
								label="Confirm Password"
								type="password"
								id="confirmPassword"
								onChange={onChangePassword}
								required
								value={
									(newUserPassword && newUserPassword.confirmPassword) ?? ""
								}
							/>
							<Button
								type="submit"
								fullWidth
								variant="contained"
								color="primary"
								className={classes.submit}
							>
								Update Password
							</Button>
						</form>
					</CardContent>
				</Card>
			</section>
		</>
	);
}

export default Profile;
